import _ from 'underscore';
import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import type {
  InstrumentationServiceContextValue,
  InstrumentationWithServiceProviderProps,
} from './types';

const defaultContextValue: InstrumentationServiceContextValue = [null, _.noop];

export const InstrumentationServiceContext =
  React.createContext<InstrumentationServiceContextValue>(defaultContextValue);

export const InstrumentationWithServiceProvider = memo((props: InstrumentationWithServiceProviderProps) => {
  const {
    context,
    children,
  } = props;

  const [instrumentationService, setInstrumentationService] = useState(context);
  const { instrumentation = null } = instrumentationService || {};

  return (
    <InstrumentationServiceContext.Provider value={[instrumentationService, setInstrumentationService]}>
      <InstrumentationContext.Provider value={instrumentation}>
        {children}
      </InstrumentationContext.Provider>
    </InstrumentationServiceContext.Provider>
  );
});

const instrumentationWithServiceProviderPropTypes = {
  context: PropTypes.shape({
    logger: PropTypes.shape({}).isRequired,
    instrumentation: PropTypes.shape({}).isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

type InstrumentationProviderComponent = typeof InstrumentationWithServiceProvider & {
  propTypes: typeof instrumentationWithServiceProviderPropTypes;
};

(InstrumentationWithServiceProvider as InstrumentationProviderComponent).propTypes =
  instrumentationWithServiceProviderPropTypes;
